import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {oauthUsuarioActivoGuard} from './infrastructure/guards/oauth-usuario-activo.guard';
import {PantallaConMenuComponent} from './infrastructure/layout/pantalla-con-menu/pantalla-con-menu.component';
import {PantallaCompletaComponent} from './infrastructure/layout/pantalla-completa/pantalla-completa.component';
import {WizardConfiguracionComponent} from "./domain/public/wizard-configuracion/wizard-configuracion.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '',
    component: PantallaConMenuComponent,
    children: [
      {
        path: 'usuarios',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/permisos/permisos.module').then(m => m.PermisosModule)
      },
      {
        path: 'listado-conversaciones',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/listado-conversaciones/listado-conversaciones.module').then(m => m.ListadoConversacionesModule)
      },
      {
        path: 'memoria',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/memoria/memoria.module').then(m => m.MemoriaModule)
      },
      {
        path: 'perfiles-conversacion',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/perfiles-conversacion/perfiles-conversacion.module').then(m => m.PerfilesConversacionModule)
      },
      {
        path: 'crear-perfil-conversacion',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/perfiles-conversacion/crear-perfil-conversacion-con-area-prueba/crear-perfil-conversacion-con-area-prueba.module').then(m => m.CrearPerfilConversacionConAreaPruebaModule)
      },
      {
        path: 'editar-perfil-conversacion/:perfilConversacionId',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/perfiles-conversacion/editar-perfil-conversacion-con-area-prueba/editar-perfil-conversacion-con-area-prueba.module').then(m => m.EditarPerfilConversacionConAreaPruebaModule)
      },
      {
        path: 'grupos',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/grupos/grupos.module').then(m => m.GruposModule)
      },
      {
        path: 'colecciones-documentos',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/colecciones-documentos/colecciones-documentos.module').then(m => m.ColeccionesDocumentosModule)
      },
      {
        path: 'inicio',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'chat',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/shared/chat/chat.module').then(m => m.ChatModule)
      },
      {
        path: 'configuracion',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/configuracion/configuracion.module').then(m => m.ConfiguracionModule)
      },
      {
        path: 'consumo-mensual',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/consumos-mensuales/consumos-mensuales.module').then(m => m.ConsumosMensualesModule)
      },
      {
        path: 'dashboard',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'documentos',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/documentos/documentos.module').then(m => m.DocumentosModule)
      },
      {
        path: 'agentes-sql',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/agentes-sql/agentes-sql.module').then(m => m.AgentesSqlModule)
      },
      {
        path: 'fuente-datos',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/fuente-datos/fuente-datos.module').then(m => m.FuenteDatosModule)
      },
      {
        path: 'agentes-extraccion',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/agentes-extraccion/agentes-extraccion.module').then(m => m.AgentesExtraccionModule)
      },
      {
        path: 'mcp-servers',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/mcp-servers/mcp-servers.module').then(m => m.McpServersModule)
      },
      {
        path: 'agentes-externos',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/agentes-externos/agentes-externos.module').then(m => m.AgentesExternosModule)
      },
      {
        path: 'agentes-api',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/agentes-api/agentes-api.module').then(m => m.AgentesApiModule)
      },
      {
        path: 'skills',
        canActivate: [oauthUsuarioActivoGuard],
        loadChildren: () => import('./domain/administrador/skills/skills.module').then(m => m.SkillsModule)
      },
    ]
  },
  {
    component: PantallaCompletaComponent,
    path: 'login',
    loadChildren: () => import('./domain/public/login/login.module').then(m => m.LoginModule)
  },
  {
    component: WizardConfiguracionComponent,
    path: 'configuracion-inicial',
    loadChildren: () => import('./domain/public/wizard-configuracion/wizard-configuracion.module').then(m => m.WizardConfiguracionModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
